module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-8x9-341c7aa039c5123acb173c07bc5ee325.jpg";